import { getNextStep } from './getNextStep';

/**
 * Для запуска механизма поиска скрытых шагов используется
 * тот же алгоритм что используется при переходе на следующий шаг
 * за исключение того что текущий шаг находится "перед" первым
 */
export var getFirstStep = function getFirstStep(params) {
  var scheme = params.scheme,
      firstStepCode = params.firstStepCode,
      skipSteps = params.skipSteps,
      answers = params.answers;
  var currentStep = {
    nextStep: [{
      conditions: [],
      nextStepCode: firstStepCode
    }]
  };
  return getNextStep({
    answers: answers,
    skipSteps: skipSteps,
    scheme: scheme,
    currentStep: currentStep
  });
};